import { render, staticRenderFns } from "./ListSale.vue?vue&type=template&id=31be2570&"
import script from "./ListSale.vue?vue&type=script&lang=js&"
export * from "./ListSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31be2570')) {
      api.createRecord('31be2570', component.options)
    } else {
      api.reload('31be2570', component.options)
    }
    module.hot.accept("./ListSale.vue?vue&type=template&id=31be2570&", function () {
      api.rerender('31be2570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ListSale.vue"
export default component.exports